module.exports = __webpack_public_path__ + "img/content.727a9a76.png";